import {useState, useEffect} from 'react'

function usePaddleLoad(vendorId) {
  const [hasVendorScriptLoaded, setHasVendorScriptLoaded] = useState()
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://cdn.paddle.com/paddle/paddle.js'
    script.async = 'true'
    script.addEventListener('load', () => {
      window.Paddle.Setup({vendor: vendorId})
      setHasVendorScriptLoaded(true)
    })
    document.body.appendChild(script)
  }, [])

  return hasVendorScriptLoaded
}

export {usePaddleLoad}
